import { render, staticRenderFns } from "./HistoricalPage.vue?vue&type=template&id=69574b56"
import script from "./HistoricalPage.vue?vue&type=script&lang=js"
export * from "./HistoricalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports